/**
 * Refonte Achats · Stock WP-13 (A-11 typo tier) — trigram similarity between two normalised words,
 * computed the way PostgreSQL pg_trgm does for one word (two spaces before, one after, set of
 * 3-grams, |A ∩ B| / |A ∪ B|). The server pre-filters candidates with pg_trgm's `<%` operator on the
 * GIN index; this function decides, so the online and offline answers are the same.
 */

/** @param {string} mot a normalised word (no space) */
export function trigrammes(mot) {
  const s = `  ${mot} `;
  const out = new Set();
  for (let i = 0; i + 3 <= s.length; i += 1) out.add(s.slice(i, i + 3));
  return out;
}

/** pg_trgm `similarity()` of two normalised words, in [0, 1]. */
export function similariteTrigrammes(a, b) {
  if (!a || !b) return 0;
  if (a === b) return 1;
  const ta = trigrammes(a);
  const tb = trigrammes(b);
  let communs = 0;
  for (const t of ta) if (tb.has(t)) communs += 1;
  return communs / (ta.size + tb.size - communs);
}

/** The best similarity of `token` with any word of `mots` (0 when none). */
export function meilleureSimilarite(token, mots) {
  let best = 0;
  for (const m of mots) {
    const s = similariteTrigrammes(token, m);
    if (s > best) best = s;
    if (best === 1) break;
  }
  return best;
}
